import type { BaseComponentProps } from "@q4/nimbus-ui";

export interface FilingBannerProps extends BaseComponentProps {
  userContext?: Record<string, unknown>;
}

export enum FilingBannerClassName {
  Base = "filing-banner",
}
